<template>
  <div class="log-device-masker flex-center">
    <div class="log-content">
      <div class="log-con-header">
        <span class="log-header-title">实时数据</span>
        <Icon class="c-blue icon" type="md-sync" />
        <span class="log-header-uptime c-blue">数据更新于{{ updataTime }}</span>
        <Icon @click="close" class="c-blue icon" type="md-close" />
      </div>
      <div class="log-con-body flex-center">
        <weaStaCard
          v-if="dataInfo"
          :macInfo="macInfo"
          :dataInfo="dataInfo"
          :type="info.type" />
      </div>
      <Spin fix v-if="loading"></Spin>
    </div>
  </div>
</template>

<script>
import weaStaCard from "./weaStaCard";
import axios from "./../utils/axios.js";
import { conversionTimeFormat } from "../utils/tool";
import { senserData } from "../utils/log-utils.js";
import { insectData, soil, soil_data, monitor } from "./../lib/mockData";
export default {
  props: ["info"],
  data() {
    return {
      // updataTime: '--',
      loading: true,
      macInfo: {
        marker: false,
        imei: "",
      },
      dataInfo: false,
    };
  },
  computed: {
    updataTime() {
      return conversionTimeFormat("YYYY-MM-dd hh:mm:ss");
    },
  },
  components: {
    weaStaCard,
  },
  created() {
    this.dataInfo = [];
    this.macInfo = {
      marker: this.info.name || false,
      imei: this.info.mac,
    };
    this.getData(this.info.monitor_type, this.info.id)
      .then((res) => {
        // setTimeout(()=>{
        this.loading = false;
        // },500)
        this.dataInfo = unit[this.info.type](
          filterDataByMonitor(this.info.monitor_type, res)
        );
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
      });
    function filterDataByMonitor(type, res) {
      if (type == 1) {
        return res;
      } else if (type == 2) {
        return res.data;
      } else if (type == 3) {
        return Object.assign({}, res.soil, { data: res.data });
      } else if (type == 4) {
        return res;
      }
    }
  },
  methods: {
    getData(type, id) {
      let map = {
        1: "sensor_data",
        2: "meteorological_data",
        3: "soil_data",
        4: "insect_data",
      };
      return new Promise((resolve, reject) => {
        axios
          .get(`/region_monitor/${map[type]}?id=${id}`)
          .then((res) => {
            if (res.status === 200) {
              resolve(res.data.data);
            } else {
            }
          })
          .catch((err) => {
            reject();
          });
      });
    },
    get_sensor_data() {
      return new Promise((resolve, reject) => {
        resolve(monitor);
      });
    },
    get_meteorological_monitor() {
      return new Promise((resolve, reject) => {
        resolve(monitor);
      });
    },
    get_soil_monitor() {
      return new Promise((resolve, reject) => {
        resolve(Object.assign({}, soil, { data: soil_data }));
      });
    },
    get_insect_lamp() {
      return new Promise((resolve, reject) => {
        resolve(insectData);
      });
    },
    close() {
      this.$emit("closeMask");
    },
  },
};
var unit = {
  sensor: function (data) {
    let weater = [];
    let monitorInfo = data.map((data) => {
      return senserData(data.number, data.data_class);
    });
    let pages = Math.ceil(monitorInfo.length / 8);
    if (pages == 1) {
      weater = monitorInfo.splice(0, 8);
    } else {
      for (let page = 0; page < pages; page++) {
        weater[page] = monitorInfo.splice(0, 8);
      }
    }
    return weater;
  },
  soil: function (data) {
    return (data.config || []).map((item) => {
      let array = data["data"].filter((data) => item.address == data.address);
      return {
        depth: item.depth,
        dataList: array.map((data) => {
          return senserData(data.number, data.data_class);
        }),
      };
    });
  },
  weater: function (data) {
    let weater = [];
    let monitorInfo = data.map((data) => {
      return senserData(data.number, data.data_class);
    });
    let pages = Math.ceil(monitorInfo.length / 8);
    if (pages == 1) {
      weater = monitorInfo.splice(0, 8);
    } else {
      for (let page = 0; page < pages; page++) {
        weater[page] = monitorInfo.splice(0, 8);
      }
    }
    return weater;
  },
  insert: function (data) {
    let insertArray = [
        {
          key: "csq",
          name: "信号",
          handlers: (data) => data || "--",
        },
        {
          key: "rps",
          name: "雨控装置",
          handlers: (data) =>
            data === 0 ? "正常" : data === 1 ? "雨控" : "--",
        },
        {
          key: "lps",
          name: "光控装置",
          handlers: (data) =>
            data === 0 ? "正常" : data === 1 ? "光控" : "--",
        },
        {
          key: "gs",
          name: "通道",
          handlers: (data) =>
            data === 0 ? "排水" : data === 1 ? "落虫" : "--",
        },
        {
          key: "hs",
          name: "加热仓",
          handlers: (data) =>
            data === 0 ? "正常" : data === 1 ? "加热" : "--",
        },
        {
          key: "data",
          name: "温度",
          unit: "℃",
          handlers: (data) => {
            let defaultValue = "--",
              result = data.filter(
                (item) => item.address == 2 && item.data_class == "temperature"
              );
            if (!data && result.length == 0) {
              return defaultValue;
            } else {
              return result[0].data["number"] || result[0].data["number"] == 0
                ? result[0].data["number"]
                : defaultValue;
            }
          },
        },
        {
          key: "upds",
          name: "上仓门",
          handlers: (data) =>
            data === 0 ? "关闭" : data === 1 ? "打开" : "--",
        },
        {
          key: "dnds",
          name: "下仓门",
          handlers: (data) =>
            data === 0 ? "关闭" : data === 1 ? "打开" : "--",
        },
        {
          key: "data",
          name: "当前温度",
          unit: "℃",
          handlers: (data) => {
            let defaultValue = "--",
              result = data.filter(
                (item) => item.address == 1 && item.data_class == "temperature"
              );
            if (!data && result.length == 0) {
              return defaultValue;
            } else {
              return result[0].data["number"] || result[0].data["number"] == 0
                ? result[0].data["number"]
                : defaultValue;
            }
          },
        },
        {
          key: "data",
          name: "当前湿度",
          unit: "%",
          handlers: (data) => {
            let defaultValue = "--",
              result = data.filter(
                (item) => item.address == 1 && item.data_class == "humidity"
              );
            if (!data && result.length == 0) {
              return defaultValue;
            } else {
              return result[0].data["number"] || result[0].data["number"] == 0
                ? result[0].data["number"]
                : defaultValue;
            }
          },
        },
        {
          key: "lng",
          name: "当前经度",
          handlers: (data) => data || "--",
        },
        {
          key: "lat",
          name: "当前纬度",
          handlers: (data) => data || "--",
        },
      ],
      insert = {};
    insertArray.forEach((item) => {
      item.data = item.handlers(data[item.key]);
      try {
        item.img = require("../assets/insert-icon/" + item.key + ".png");
      } catch (e) {
        item.img = null;
      }
    });
    insert.top = [
      [[...insertArray.slice(0, 2)], [...insertArray.slice(2, 4)]],
      [[...insertArray.slice(4, 6)], [...insertArray.slice(6, 8)]],
    ];
    insert.bottom = [...insertArray.slice(8, 12)];
    return insert;
  },
};
</script>

<style scoped>
.ivu-spin-fix {
  opacity: 0.6;
  background: transparent;
}

.log-con-body {
  background: rgba(0, 36, 62, 0.8);
  padding: 0.75vw 1vw;
}

.c-blue {
  color: #01bae1;
}

.icon:last-child {
  cursor: pointer;
  margin-left: auto;
  right: 0;
  font-size: 1vw;
}

.icon {
  font-size: 1vw;
}

.log-header-title {
  text-align: right;
  font-size: 1vw;
  flex-shrink: 0;
  padding-right: 0.5vw;
}

.log-con-header {
  font-size: 0.7vw;
  line-height: 1;
  display: flex;
  align-items: center;
  background: rgba(0, 14, 25, 0.8);
  padding: 0.6vw 1vw;
}

.log-content div {
  box-sizing: content-box;
}

.log-content {
  position: relative;
  border: 0.05vw solid #02a6ca;
  box-shadow: 0 0 0.2vw 0.2vw rgba(2, 166, 202, 0.4);
}

.log-device-masker {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 3;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
